export const APPLY_CART = "APPLY_CART";
export const APPLY_CART_PRODUCTS = "APPLY_CART_PRODUCTS";
export const APPLY_ADDONS = "APPLY_ADDONS";
export const APPLY_SELECTED_ADDON = "APPLY_SELECTED_ADDON";